import { Component, Injectable } from '@angular/core';
//import { ClearanceItemService } from "./../clearance-item/clearance-item.service";
import { ListSearchData, CIImage, CIRestriction, CITag, CIDocument, ClearanceItem, MassUpdateData } from '../clearance-item/clearance-item.model';
import { Observable } from 'rxjs/Observable';
import { Http, Response, Headers } from '@angular/http';
import { AuthService } from '../shared/core/auth.service';
import { AdvancedSearchData } from './search.model';
import { DatePipe } from '@angular/common';
import { ILookup } from '../shared/lookup';
import { AppUtils } from '../shared/utils';
import { HttpService } from '../shared/core/http.service';

@Injectable()
export class SearchService {
    private advSearch = new URL('advsearch', process.env.API_URL).toString();    
    private ciListServiceAPIUrl = new URL('cilist', process.env.API_URL).toString();

    constructor(private _httpService: HttpService, private _authService: AuthService) {

    }

    search(listSearchData: AdvancedSearchData): Observable<AdvancedSearchData> {
        // console.log('calling search() at ' + this.advSearch + ' for  ' + JSON.stringify(listSearchData));
        
        var body = JSON.stringify(listSearchData);
        return this._httpService.httpPost(this.advSearch, body)
            .map((response: Response) => {
                return this.mapListSearchData(response);
            })
            .do(data => data)
            // .catch((e) => {
            //     // handle e and return a safe value or rethrow
            //     console.error('error on SearchService.search(): ' + e);
            //     return Observable.of<any>([]);
            // })
            // ;
    }

    mapListSearchData(response: Response): AdvancedSearchData {
        var ret = this.toListSearchData(response.json());
        return ret;
    }
    toListSearchData(data: any): AdvancedSearchData {
        if (data) {
            console.log(data);
            let listSearchData: AdvancedSearchData = new AdvancedSearchData();
            // listSearchData.filterBy = data.FilterBy;
            // listSearchData.filterString = data.FilterString;
            listSearchData.pageStartIndex = data.PageStartIndex;
            listSearchData.pageSize = data.PageSize;
            listSearchData.projectId = data.ProjectId;
            listSearchData.resultSet = data.ResultSet;
            listSearchData.sortBy = data.SortBy;
            listSearchData.sortOrder = data.SortOrder;
            listSearchData.status = data.Status;
            listSearchData.totalNumberOfRecords = data.TotalNumberOfRecords;
            listSearchData.resultSet = [];
            if (data.ResultSet) {
                data.ResultSet.forEach(element => {
                    listSearchData.resultSet.push(this.toClearanceItem(element));
                });
            }
            return listSearchData;
        }
    }
    toClearanceItem(ci: any): ClearanceItem {

        // console.log('toClearanceItem where ci:' + JSON.stringify(ci));
        var datePipe = new DatePipe('en-US');

        let clearanceItem = <ClearanceItem>
            ({
                id: ci.Id,
                name: ci.Name,
                createdDate: ci.CreatedDate ? datePipe.transform(ci.CreatedDate, 'MM-dd-yyyy') : ci.CreatedDate,
                artistAuthorName: ci.ArtistAuthorName,
                copyrightInfo: ci.CopyrightInfo,
                deadline: ci.Deadline ? datePipe.transform(ci.Deadline, 'MM-dd-yyyy') : ci.Deadline,
                description: ci.Description,
                isCreatedByProd: ci.IsCreatedByProd,
                projectId: ci.ProjectId,
                projectName: ci.ProjectName,
                refUrl: ci.RefUrl,
                scene: ci.Scene,
                episode: ci.Episode,
                season: ci.Season,
                status: ci.Status,
                reportGroupName: ci.ReportGroupName,
                ciUniqueId: ci.CIUniqueId

            });

        clearanceItem.documents = new Array<CIDocument>();

        if (ci.Documents) {
            ci.Documents.forEach(element => {
                var doc: CIDocument = <CIDocument>(
                    {
                        id: element.Id,
                        name: element.Name,
                        fileType: (element.FileType ? element.FileType : 'application/octet-stream'),
                        urlName: element.UrlName,
                        dMNumber: element.DMNumber,
                        cIId: element.CIId,
                        savedId: element.Id,
                        loading: false,
                        fullUrl: element.FullUrl
                    });
                clearanceItem.documents.push(doc);
            });
        }
        clearanceItem.tags = new Array<CITag>();
        if (ci.Tags) {
            ci.Tags.forEach(element => {
                var tag: CITag = <CITag>(
                    {
                        id: element.Id,
                        tagName: element.TagName,
                        tagId: element.TagId,
                        cIId: element.CIId,
                        tagType: element.TagType
                    });
                clearanceItem.tags.push(tag);
            });
            clearanceItem.tags = AppUtils.SortTags(clearanceItem.tags);
        }
        clearanceItem.restrictions = new Array<CIRestriction>();
        if (ci.Restrictions) {
            ci.Restrictions.forEach(element => {
                var restriction: CIRestriction = <CIRestriction>(
                    {
                        id: element.Id,
                        restrictionType: element.RestrictionType,
                        description: element.Description,
                        cIId: element.CIId
                    });
                clearanceItem.restrictions.push(restriction);
            });
        }
        clearanceItem.images = new Array<CIImage>();
        if (ci.Images) {
            ci.Images.forEach(element => {
                var ciImage: CIImage = <CIImage>(
                    {
                        id: element.Id,
                        fileType: (element.FileType ? element.FileType : 'application/octet-stream'),
                        urlName: element.UrlName,
                        name: element.Name,
                        defaultC: element.DefaultC,
                        showOnReports: element.ShowOnReports,
                        cIId: element.CIId,
                        fullUrl: element.FullUrl,
                        savedId: element.Id,
                        assetType: element.AssetType ? element.AssetType : 'Image'                        
                    });
                clearanceItem.images.push(ciImage);
            });
        }

        clearanceItem.titles = new Array<ILookup>();
        if (ci.Titles){
            ci.Titles.forEach(element => {
                var title:ILookup =<ILookup>({
                    id: element.id,
                    name: element.name,
                    type: element.type
                })
                clearanceItem.titles.push(title);
            });
        }

        return clearanceItem;
    }
    private handleError(error: Response) {
        // console.error('error!:' + error.json());
        return Observable.throw(error || 'Server error');
    }
    massUpdateItems(massUpdateData: MassUpdateData): Observable<boolean> {
        
        console.log('calling massUpdateItems() at ' + this.ciListServiceAPIUrl + ' for  ' + JSON.stringify(massUpdateData));
        var body = JSON.stringify(massUpdateData);
        return this._httpService.httpPut(this.ciListServiceAPIUrl, body)
            .map((response: Response) => {
                if (response.status == 200)
                    return Observable.of(true);
                else
                    return Observable.of(false);
            })
            .do(data => data)
            .catch(this.handleError);
    }

    downloadImages(CIIds: string): Observable<Response>{
        let userRoles = this._authService.userRoles; 
        const url = this.advSearch + '/downloadImages?Ids=' + encodeURIComponent(CIIds);
        return this._httpService.httpGetFile(url,'application/zip', userRoles);
    }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/search/search.service.ts